<template>
  <div class="user-create">
    <h2>创建用户</h2>
    <form @submit.prevent="createUser">
      <div v-for="field in fields" :key="field.name" class="form-group">
        <label :for="field.name">{{ field.label }}</label>
        <input
            v-if="field.type !== 'textarea'"
            :type="field.type"
            :id="field.name"
            v-model="form[field.name]"
            :placeholder="'请输入' + field.label"
            required
        />
        <textarea
            v-if="field.type === 'textarea'"
            :id="field.name"
            v-model="form[field.name]"
            :placeholder="'请输入' + field.label"
            required
        ></textarea>
      </div>
      <button type="submit">提交</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "UserCreate",
  data() {
    return {
      // 表单字段
      fields: [
        { name: "rentalUserName", label: "租赁用户名", type: "text" },
        { name: "rentalUserAlias", label: "租赁用户别名", type: "text" },
        { name: "createBy", label: "创建人", type: "text" },
        { name: "createDate", label: "创建时间", type: "datetime-local" },
        { name: "updateBy", label: "修改人", type: "text" },
        { name: "updateDate", label: "修改时间", type: "datetime-local" },
        { name: "rentalUserIndex", label: "用户索引", type: "text" },
        { name: "createUserNum", label: "创建用户数", type: "number" },
        { name: "balance", label: "账户余额", type: "number" },
      ],
      // 表单数据
      form: {
        rentalUserName: "",
        rentalUserAlias: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        rentalUserIndex: "",
        createUserNum: null,
        balance: null,
      },
    };
  },
  methods: {
    // 提交表单
    async createUser() {
      try {
        const response = await axios.post("/api/users", this.form);
        alert("用户创建成功！");
        console.log(response.data);
        // 清空表单
        this.resetForm();
      } catch (error) {
        console.error("创建用户失败：", error);
        alert("创建用户失败，请稍后重试！");
      }
    },
    // 重置表单
    resetForm() {
      this.form = {
        rentalUserName: "",
        rentalUserAlias: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        rentalUserIndex: "",
        createUserNum: null,
        balance: null,
      };
    },
  },
};
</script>

<style scoped>
.user-create {
  width: 400px;
  margin: auto;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  margin-top: 15px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
